import { render, staticRenderFns } from "./DeliverySkipReasonModal.vue?vue&type=template&id=22b8ff59&scoped=true&"
import script from "./DeliverySkipReasonModal.vue?vue&type=script&lang=js&"
export * from "./DeliverySkipReasonModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySkipReasonModal.vue?vue&type=style&index=0&id=22b8ff59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8ff59",
  null
  
)

export default component.exports